
























































import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Farm from '@/components/farms/Farm.vue'
import benis from '@/store/modules/benis'
import { FarmConfig } from '@/config/constants/types'
import TokensUtil from '@/utils/TokensUtil'
import { ethers } from 'ethers'
import BenisUtils from '@/utils/BenisUtils'
import { BN_ZERO } from '@/models/FarmData'
import { Benis } from '@artifacts/typechain'
import { sleep } from '@/utils/AsyncUtils'
import { Network } from '@/utils/Networks'
import accounts from '@/store/modules/accounts'

const benisStore = namespace('benis')
const accountsStore = namespace('accounts')

@Component({
	components: {
		Farm,
	},
})
export default class FarmsPage extends Vue {
	@benisStore.Getter('farms')
	allFarms!: Array<FarmConfig>

	@accountsStore.State('activeAccount')
	activeAccount!: string

	@accountsStore.State('network')
	currentBlockchain!: Network

	@accountsStore.Getter('providerEthers')
	provider!: ethers.providers.Web3Provider | null

	@accountsStore.Getter('isUserConnected')
	isUserConnected!: boolean

	@benisStore.Getter('benisContract')
	benis!: Benis

	farmsSelected = 'active'

	userHasDepositsInEndedFarms = false

	wbanAddress: string = TokensUtil.getWBANAddress()

	loading = true

	benisUtils = new BenisUtils()

	static ENV_NAME: string = process.env.VUE_APP_ENV_NAME || ''

	get selectedFarms(): Array<FarmConfig> {
		return this.farmsSelected === 'active' ? this.activeFarms : this.endedFarms
	}

	get activeFarms(): Array<FarmConfig> {
		return (
			this.allFarms
				// only keep farms not ended
				.filter((farm) => !farm.ended)
		)
	}

	get endedFarms(): Array<FarmConfig> {
		return (
			this.allFarms
				// only keep farms ended
				.filter((farm) => farm.ended)
		)
	}

	async onProviderChange() {
		this.loading = true
		await benis.initContract(this.provider)
		this.loading = false
		// find out if there are some user deposits in ended farms
		const userNeedsWithdrawal = await this.findAsyncSequential(this.endedFarms, async (farm) => {
			const deposits = await this.benisUtils.getStakedBalance(farm.pid, this.activeAccount, this.benis)
			return deposits.gt(BN_ZERO)
		})
		if (userNeedsWithdrawal) {
			this.userHasDepositsInEndedFarms = true
		}
	}

	async mounted() {
		await accounts.initWalletProvider()
		console.warn('User connected?', this.isUserConnected)
		if (!this.isUserConnected) {
			await accounts.connectWalletProvider()
		}
		// wait for Web3 provider to be ready
		while (!this.provider) {
			await sleep(100)
		}
		await this.onProviderChange()
		document.addEventListener('web3-connection', this.onProviderChange)
	}

	unmounted() {
		document.removeEventListener('web3-connection', this.onProviderChange)
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
	private async findAsyncSequential<T>(array: T[], predicate: (t: T) => Promise<boolean>): Promise<T | undefined> {
		for (const t of array) {
			if (await predicate(t)) {
				return t
			}
		}
		return undefined
	}
}
